import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const LoadingComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-w-full">
      <div className="tw-absolute top-50 d-flex  justify-content-center align-items-center flex-column">
        <Spinner animation="border" variant="success" />

        <span className="tw-mt-4 tw-font-semibold">{t('LoadingComponent/text')}</span>
      </div>
    </div>
  );
};

export default LoadingComponent;
